class PrimerryArticleProduct extends HTMLElement {
  connectedCallback() {
    if (this.dataset.articleProductReady === 'true') return;
    this.dataset.articleProductReady = 'true';
    this.kids = 1;
    this.addEventListener('click', (event) => this.handleClick(event));
    this.addEventListener('change', (event) => this.handleChange(event));
    this.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  handleClick(event) {
    const thumb = event.target.closest('[data-article-product-thumb]');
    if (thumb && this.contains(thumb)) {
      this.selectThumb(thumb);
      return;
    }

    const kid = event.target.closest('[data-article-product-kids]');
    if (kid && this.contains(kid)) this.selectKids(kid);
  }

  handleChange(event) {
    const input = event.target.closest('input[name^="article-product-variant-"]');
    if (!input || !this.contains(input)) return;
    const card = input.closest('[data-article-product-variant-card]');
    if (card) this.selectVariant(card);
  }

  selectThumb(button) {
    const image = this.querySelector('.primerry-article-product__main-image-element');
    if (image && button.dataset.mediaSrc) {
      image.src = button.dataset.mediaSrc;
      image.srcset = '';
    }
    this.querySelectorAll('[data-article-product-thumb]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  selectKids(button) {
    this.kids = Number(button.dataset.articleProductKids || 1);
    this.querySelectorAll('[data-article-product-kids]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    const quantity = this.querySelector('[data-article-product-quantity-input]');
    if (quantity) quantity.value = String(this.kids);
  }

  selectVariant(card) {
    this.querySelectorAll('[data-article-product-variant-card]').forEach((item) => {
      item.classList.toggle('is-active', item === card);
    });

    const variantInput = this.querySelector('[data-article-product-variant-input]');
    if (variantInput) variantInput.value = card.dataset.variantId || '';

    const price = this.querySelector('[data-article-product-price]');
    const compare = this.querySelector('[data-article-product-compare]');
    const discount = this.querySelector('[data-article-product-discount]');
    if (price) price.textContent = card.dataset.price || '';
    if (compare) {
      compare.textContent = card.dataset.compare || '';
      compare.hidden = !card.dataset.compare;
    }
    if (discount) {
      discount.textContent = card.dataset.discount || '';
      discount.hidden = !card.dataset.discount;
    }

    const button = this.querySelector('[data-article-product-form] [type="submit"]');
    if (button) {
      const available = card.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? (button.dataset.defaultLabel || 'add to cart') : 'sold out';
    }
  }

  async handleSubmit(event) {
    const form = event.target.closest('[data-article-product-form]');
    if (!form || !this.contains(form)) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-article-product-error]');
    if (!button || button.dataset.loading === 'true') return;

    const defaultLabel = button.dataset.defaultLabel || button.textContent;
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'adding...';
    if (error) error.hidden = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin',
      });
      const item = await response.json();
      if (!response.ok) throw new Error(item.description || item.message || 'Unable to add this product.');

      const [cart, sections] = await Promise.all([
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((result) => result.json()),
        fetch(`${window.location.pathname}?sections=cart-drawer-section`, { credentials: 'same-origin' }).then((result) => result.json()),
      ]);

      const currentDrawer = document.querySelector('#shopify-section-cart-drawer-section');
      if (sections['cart-drawer-section'] && currentDrawer) {
        const template = document.createElement('template');
        template.innerHTML = sections['cart-drawer-section'].trim();
        if (template.content.firstElementChild) currentDrawer.replaceWith(template.content.firstElementChild);
      }

      document.querySelectorAll('.primerry-header__cart-count').forEach((count) => {
        count.textContent = String(Math.min(cart.item_count, 99));
        count.classList.toggle('primerry-header__cart-count--empty', cart.item_count === 0);
      });

      requestAnimationFrame(() => document.querySelector('.primerry-header__cart')?.click());
    } catch (submitError) {
      if (error) {
        error.textContent = submitError instanceof Error ? submitError.message : 'Unable to add this product.';
        error.hidden = false;
      }
    } finally {
      button.dataset.loading = 'false';
      const activeCard = this.querySelector('[data-article-product-variant-card].is-active');
      const available = activeCard?.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? defaultLabel : 'sold out';
    }
  }
}

if (!customElements.get('primerry-article-product')) {
  customElements.define('primerry-article-product', PrimerryArticleProduct);
}
